export default function formatArea(
  area: number | string | null,
): string | null {
  if (area === null) {
    return null;
  }

  const numericArea = Number(area);

  if (isNaN(numericArea)) {
    return area as string;
  }

  const formattedArea = numericArea?.toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  return formattedArea;
}
